import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import UserRole from '@/components/System/User/UserRole';
import UserDetail from '@/components/System/User/UserDetail';
import UserSync from '@/components/System/User/UserSync';
import UserOrg from '@/components/System/User/UserOrg';
import UserAdd from '@/components/System/User/UserAdd';
export default {
  components: {
    SearchForm: SearchForm,
    UserRole: UserRole,
    UserDetail: UserDetail,
    UserSync: UserSync,
    UserOrg: UserOrg,
    UserAdd: UserAdd
  },
  data: function data() {
    return {
      showUserRole: false,
      showUserDetail: false,
      showUserSync: false,
      showOrg: true,
      showUser: false,
      checkAll: false,
      isIndeterminate: false,
      searchFormData: [{
        title: '用户名',
        key: 'sysName',
        placeholder: '请选择系统名称',
        type: 'select',
        selectData: [],
        selectedArr: [],
        multiple: true
      }, {
        title: '用户编号',
        key: 'role',
        placeholder: '请选择系统名称',
        type: 'input',
        value: null,
        selectData: [],
        selectedArr: []
      }],
      btnType: 'reset,search,add',
      userRoleTitle: '用户角色配置（李四/000002）',
      userTitle: '新增用户',
      tableData: [{
        roleNum: '0000001',
        sysName: '法律合规门户',
        roleName: '总行超级管理员',
        roleType: '总行',
        roleExplain: '角色用户用于管理总行所有制度',
        roleStatus: '有效',
        checked: false
      }, {
        roleNum: '0000001',
        sysName: '法律合规门户',
        roleName: '总行超级管理员',
        roleType: '总行',
        roleExplain: '角色用户用于管理总行所有制度',
        roleStatus: '有效',
        checked: true
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      data: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }]
    };
  },
  computed: {},
  methods: {
    searchForm: function searchForm() {},
    exportTable: function exportTable() {},
    resetForm: function resetForm() {},
    addTable: function addTable() {
      this.showUser = true;
    },
    handleSelectionChange: function handleSelectionChange() {},
    delUser: function delUser() {
      var useArr = this.checkAll ? this.tableData : this.tableData.filter(function (item) {
        return item.checked;
      });
      // eslint-disable-next-line no-unused-vars
      var userIdArr = useArr.map(function (item) {
        return item.roleNum;
      });
    },
    clickDep: function clickDep() {},
    changeAll: function changeAll(e) {
      this.isIndeterminate = false;
      if (e) {
        // eslint-disable-next-line no-return-assign
        this.tableData.forEach(function (item) {
          return item.checked = true;
        });
      } else {
        // eslint-disable-next-line no-return-assign
        this.tableData.forEach(function (item) {
          return item.checked = false;
        });
      }
    },
    changeItem: function changeItem() {
      if (this.tableData.every(function (item) {
        return item.checked;
      })) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else if (this.tableData.some(function (item) {
        return item.checked;
      })) {
        this.checkAll = false;
        this.isIndeterminate = true;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    seeUserDialog: function seeUserDialog() {
      this.showUserDetail = true;
    },
    editRoleDialog: function editRoleDialog() {
      this.showUserRole = true;
    },
    syncUserDialog: function syncUserDialog() {
      this.showUserSync = true;
    },
    editOrgDialog: function editOrgDialog() {
      this.showOrg = true;
    },
    editUserDialog: function editUserDialog() {
      this.showUser = true;
    },
    deleteUser: function deleteUser() {}
  }
};